var exports = {
  "wm": "xfb577c5e--f550ee--logo",
  "_8": "xfb577c5e--f550ee--img",
  "DD": "xfb577c5e--f550ee--title",
  "cL": "xfb577c5e--f550ee--builder",
};

module.exports = exports;
